// Time-of-day emoji maps (Morning/Afternoon/Evening) are intentionally not
// centralized: general vs specific availability use different emoji by design.

export const DAY_ABBREV: Record<string, string> = {
  Sunday: 'Sun',
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
};
